import { API } from './resources'

export default {
  getFairsForProject: (projectID) => {
    return API.get(`/projects/${projectID}/fairs`)
  },
  createFairProject: (projectID, data) => {
    return API.put(`/projects/${projectID}/submitToFairs`, data)
  }
}
